import { render, staticRenderFns } from "./com_num.vue?vue&type=template&id=48c45600&"
import script from "./com_num.vue?vue&type=script&lang=js&"
export * from "./com_num.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports